import { Image, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import DownloadIcon from "../../../../assets/icons/DownloadIcon";
import NoteIcon from "../../../../assets/icons/NoteIcon";
import FileImage from "../../../../assets/images/file.svg";
import PDFImage from "../../../../assets/images/pdf.svg";
import CorrectActtionIcon from "../../../../components/common/CorrectActtionIcon";
import CrossActionIcon from "../../../../components/common/CrossActionIcon";
import ConfirmModal from "../../../../components/ui/ConfirmModal";
import CustomModal from "../../../../components/ui/CustomModal";
import CustomTable from "../../../../components/ui/CustomTable";
import { useReviewAssignmentMutation } from "../../../../features/organization/job/jobApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";
import { capitalize, getExtension } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";
import { AssignmentDataType } from "../MyProjectDetails";

type ModalProps = "APPROVED" | "REJECT";

export default function AssignmentModal({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<AssignmentDataType>) {
  const {
    open,
    handleOpen,
    handleClose: confirmClose,
  } = useModal<any, ModalProps>();
  const [reviewAssignment, { isLoading, isError, isSuccess, error, reset }] =
    useReviewAssignmentMutation();
  useError(isError, error, "Failed to review assignment");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (isSuccess && open?.type) {
      if (open?.type === "APPROVED") {
        toast("success", "Assignment approved successfully");
        confirmClose();
        reset();
        // handleClose();
      } else if (open?.type === "REJECT") {
        toast("success", "Assignment rejected successfully");
        confirmClose();
        reset();
        // handleClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, open?.type]);

  useEffect(() => {
    setNote("");
  }, [open?.open, open?.type]);

  return (
    <CustomModal
      width={600}
      className={`confirm-modal`}
      handleClose={handleClose}
      title="Assignment"
      footer={null}
      {...rest}
    >
      {open?.type === "APPROVED" && (
        <ConfirmModal
          open={open?.open}
          handleClose={confirmClose}
          handleOk={() => {
            reviewAssignment({
              id: data?.id,
              data: {
                assignment: data?.data?.map((_, idx) => {
                  if (idx === open?.data?.index) {
                    return {
                      ..._,
                      status: "approved",
                    };
                  }
                  return _;
                }),
              },
            });
          }}
          title="Approve Assignment"
          subTitle="Are you sure you want to approve this assignment?"
          okText="Approve"
          okLoading={isLoading}
        />
      )}
      {open?.type === "REJECT" && (
        <ConfirmModal
          open={open?.open}
          handleClose={confirmClose}
          handleOk={() => {
            reviewAssignment({
              id: data?.id,
              data: {
                assignment: data?.data?.map((_, idx) => {
                  if (idx === open?.data?.index) {
                    return {
                      ..._,
                      status: "rejected",
                      remarks: note,
                    };
                  }
                  return _;
                }),
              },
            });
          }}
          title="Reject Assignment"
          subTitle="Are you sure you want to reject this assignment?"
          okText="Reject"
          okLoading={isLoading}
          okButtonProps={{
            disabled: !note,
          }}
          children={
            <div className="mt-4">
              <TextArea
                placeholder="Enter reject note..."
                rows={3}
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
          }
        />
      )}
      <div className="max-h-[500px]">
        {/* <div className="grid grid-cols-3 border border-slate-300">
          <div className="col-span-2 border-r border-b border-slate-300 p-2 font-medium text-center">
            Assignment
          </div>
          <div className="p-2 border-b border-slate-300 font-medium text-center">
            Status
          </div>
          {data?.data?.map((_, idx) => (
            <Fragment key={idx}>
              <div className="col-span-2 border-r border-slate-300 p-2 -my-1 flex items-center border-b">
                {data?.data &&
                (data?.data?.startsWith("http") ||
                  data?.data?.startsWith("https")) ? (
                  <a
                    href={data?.data}
                    className="text-link hover:text-link no-underline hover:underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {data?.data}
                  </a>
                ) : (
                  <div className="text-slate-700 text-sm">{data?.data}</div>
                )}
              </div>

              <div className="p-2 flex items-center justify-center border-b border-slate-300">
                {data?.status ? (
                  <div className="flex items-center gap-1">
                    <span
                      className={
                        data?.status === "approved"
                          ? "status-success"
                          : data?.status === "rejected"
                          ? "status-danger"
                          : ""
                      }
                    >
                      {capitalize(data?.status)}{" "}
                    </span>
                    {data?.status === "rejected" && !!data?.remarks && (
                      <Tooltip title={data?.remarks}>
                        <span className="cursor-pointer bg-gray text-body-text text-xs w-4 h-4 rounded-full flex items-center justify-center">
                          ℹ
                        </span>
                      </Tooltip>
                    )}
                  </div>
                ) : (
                  <div className="w-full flex justify-center items-center gap-2">
                    <button
                      onClick={() => {
                        handleOpen({
                          type: "APPROVED",
                          data: data?.id,
                        });
                      }}
                      className="cursor-pointer"
                    >
                      <CorrectActtionIcon />
                    </button>

                    <button
                      onClick={() => {
                        handleOpen({
                          type: "REJECT",
                          data: data?.id,
                        });
                      }}
                      className="cursor-pointer"
                    >
                      <CrossActionIcon />
                    </button>
                  </div>
                )}
              </div>
            </Fragment>
          ))}
        </div> */}

        <CustomTable
          dataSource={addKeyInArray(data?.data || [])}
          columns={[
            {
              title: "Assignment",
              dataIndex: "content",
              render: (val, record) => (
                <>
                  {record?.type === "text" ? (
                    <div className="text-slate-700 text-sm">{val}</div>
                  ) : (
                    <div className="text-slate-700 text-sm flex items-end gap-0.5">
                      {getExtension(val) === "pdf" ? (
                        <Image
                          src={PDFImage}
                          width={60}
                          height={70}
                          preview={false}
                        />
                      ) : getExtension(val) === "png" ||
                        getExtension(val) === "jpg" ||
                        getExtension(val) === "jpeg" ||
                        getExtension(val) === "webp" ||
                        getExtension(val) === "svg" ? (
                        <Image src={val} width={60} height={70} />
                      ) : (
                        <Image
                          src={FileImage}
                          width={60}
                          height={70}
                          preview={false}
                        />
                      )}
                      <a
                        href={val}
                        className="text-link hover:text-link no-underline hover:underline ml-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        download={val}
                      >
                        <DownloadIcon />
                      </a>
                    </div>
                  )}
                </>
              ),
            },
            {
              title: "Status",
              dataIndex: "status",
              align: "center",
              render: (val, record, idx) => (
                <div className="w-full flex justify-center items-center">
                  {!val || val === "pending" ? (
                    <div className="w-full flex justify-center items-center gap-2">
                      <button
                        onClick={() => {
                          handleOpen({
                            type: "APPROVED",
                            data: {
                              index: idx,
                              status: "approved",
                            },
                          });
                        }}
                        className="cursor-pointer"
                      >
                        <CorrectActtionIcon />
                      </button>

                      <button
                        onClick={() => {
                          handleOpen({
                            type: "REJECT",
                            data: {
                              index: idx,
                              status: "rejected",
                            },
                          });
                        }}
                        className="cursor-pointer"
                      >
                        <CrossActionIcon />
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center gap-1">
                      <span
                        className={
                          val === "approved"
                            ? "status-success"
                            : val === "rejected"
                            ? "status-danger"
                            : ""
                        }
                      >
                        {capitalize(val)}{" "}
                      </span>
                      {val === "rejected" && !!record?.remarks && (
                        <Tooltip title={record?.remarks}>
                          <span className="cursor-pointer text-body-text text-xs w-3.5 h-3.5 rounded-full flex items-center justify-center">
                            <NoteIcon />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              ),
            },
          ]}
          hidePagination={true}
        />
      </div>
    </CustomModal>
  );
}
